import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown, Avatar } from 'antd'
import styles from './style.module.scss'
import { ReducerType } from "../../../../redux/reducer.type";
import { MenuUserPropsType, MenuUserStateType } from "./menuUser.type";
import actions from "../../../../redux/user/actions";
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
import {faSignOutAlt, faUser, faCheck} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ROUTE_PROFILE_EDIT } from "../../../../config/routes";
import { Link } from "react-router-dom";
import {WorkspaceType} from "../../../../redux/user/user.type";
import {languages} from "../../../../config/config";
import { Select } from 'antd';
import i18n from '../../../../i18n';

const { Option } = Select;

class ProfileMenu extends React.Component<MenuUserPropsType, MenuUserStateType> {
    state = {
        visible: false,
    };
    handleVisibleChange = (flag: boolean) => {
        this.setState({ visible: flag });
    };
    logout = () => {
        const { dispatch } = this.props;
        dispatch({
            type: actions.LOGOUT,
        })
    };

    changeWorkspace = (el: WorkspaceType) => {
        const { dispatch } = this.props;
        dispatch({
            type: actions.CHANGE_ACTIVE_WORKSPACE,
            payload: el
        });
    };

    changeLanguage = (value: string) => {
        localStorage.setItem('language', value);
        i18n.changeLanguage(value);
    };

  render() {
    const { user, t } = this.props;
    const menu = (
      <Menu
          selectable={false}
          style={{minWidth: 250}}
      >
        <Menu.Item>
          <strong>{t('user_menu_prefix_user')}, {user.first_name}</strong>
        </Menu.Item>
        <Menu.Divider />
          {user.workspaces.map((el => {
              return (user.activeWorkspace && el.uuid === user.activeWorkspace.uuid ? (
                  <Menu.Item key={el.uuid}>
                      <FontAwesomeIcon icon={faCheck} className={styles.menuIcon} />
                      <strong>{user.activeWorkspace.name}</strong>
                  </Menu.Item>
              ) : (
                  <Menu.Item onClick={() => this.changeWorkspace(el)} key={el.uuid}>
                      <span style={{marginLeft: 18}}>
                          {el.name}
                      </span>
                  </Menu.Item>
              ))
          }))}
        <Menu.Divider />
          <Menu.Item>
              <Link to={ROUTE_PROFILE_EDIT} >
                  <FontAwesomeIcon icon={faUser} className={styles.menuIcon} />
                  {t('menu_user_edit_profile')}
              </Link>
          </Menu.Item>
          <Menu.Item>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{marginLeft: 16}}>{t('menu_user_change_language')}</span>
                  <Select defaultValue={i18n.language} size="small" onChange={this.changeLanguage}>
                      {languages.map(el => (
                          <Option key={el.i18n} value={el.i18n}>{el.name}</Option>
                      ))}
                  </Select>
              </div>
          </Menu.Item>
          <Menu.Divider />
        <Menu.Item onClick={this.logout} >
          <button type="button" className="linkButton">
            <FontAwesomeIcon icon={faSignOutAlt} className={styles.menuIcon} />
              {t('user_menu_logout')}
          </button>
        </Menu.Item>
      </Menu>
    );
    return (
        <>
            <Dropdown
                overlay={menu}
                trigger={['click']}
                onVisibleChange={this.handleVisibleChange}
                visible={this.state.visible}
            >
                <div className={styles.dropdown}>
                    <Avatar className={styles.avatar} shape="square" size="large" icon="user" />
                </div>
            </Dropdown>
        </>
    )
  }
}

const mapStateToProps = (state: ReducerType) => ({ user: state.user });

export default compose<MenuUserPropsType, {}>(
    connect(mapStateToProps),
    withTranslation('template')
)(ProfileMenu)
